module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/star4.b171f43b.png";